import { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import { RiSendPlane2Fill } from 'react-icons/ri'

const Input = ({ onEnter }: { onEnter: (value: string) => void }) => {
  const [text, setText] = useState('')
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleEnter()
    }
  }

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value)
  }

  const handleEnter = () => {
    setText('')
    onEnter(text)
  }

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`
    }
  }, [text])

  return (
    <Container>
      <TextArea
        ref={textAreaRef}
        rows={1}
        onKeyDown={handleKeyDown}
        onChange={handleTextChange}
        placeholder='Poser une question'
        value={text}
      />
      <Button onClick={handleEnter} disabled={text.length === 0}>
        <RiSendPlane2Fill />
      </Button>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  padding-top: 18px;
  border: 1px solid ${({ theme }) => theme.colorGrey};
  background: ${({ theme }) => theme.colorSiteBackground};

  box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`

const Button = styled.div<{ disabled: boolean }>`
  position: absolute;
  bottom: 15px;
  right: 15px;
  height: 3.3rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ theme, disabled }) =>
    disabled ? theme.colorGreyDark : theme.colorMain};
  transform: scale(${({disabled}) => disabled ? 0.85 : 1.1});
  transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;
`

const TextArea = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  font-size: 1.9rem;
  line-height: 1.4;
  font-family: var(--font-sans-serif);
  resize: none;
  overflow: auto;
  background: ${({ theme }) => theme.colorSiteBackground};
  color: ${({ theme }) => theme.colorText};

  &::placeholder {
    color: ${({ theme }) => theme.colorGreyDark};
    -webkit-font-smoothing: antialiased;
  }
`

export default Input
